import { apiGet, apiPatch, apiPost, apiRequest } from '../../../apiClient';

export const getBranchStatus = (token) => apiGet('/branches/status', token);

export const listBranches = (token) => apiGet('/branches', token);

export const getBranch = (branchId, token) => apiGet(`/branches/${branchId}`, token);

export const createBranch = (payload, token) => apiPost('/branches', payload, token);

export const updateBranch = (branchId, payload, token) =>
  apiPatch(`/branches/${branchId}`, payload, token);

export const deleteBranch = (branchId, token) =>
  apiRequest(`/branches/${branchId}`, { method: 'DELETE', token });
